import { render, staticRenderFns } from "./emailForm.vue?vue&type=template&id=3b25f520&scoped=true&"
import script from "./emailForm.vue?vue&type=script&lang=js&"
export * from "./emailForm.vue?vue&type=script&lang=js&"
import style0 from "./emailForm.vue?vue&type=style&index=0&id=3b25f520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b25f520",
  null
  
)

export default component.exports